import React, { useEffect, useState } from 'react';
import NextPrevButtons from '../Shared/NextPrevButtons';
import { makeStyles, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { MuiPickersUtilsProvider, KeyboardDatePicker, validate } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

export default function ValidUntill(props) {

    const classes = useStyles();
    const [date, setDate] = useState(null)

    useEffect(() => {

        if (props.chosenValue) {
            if (JSON.stringify(date) !== JSON.stringify(props.chosenValue)) {
                setDate(props.chosenValue)
            }
        } 
    }, [])

    const setNextStep = () => {
        validate()       
    }

    const validate = () => {
        if(date >= props.addPage.contractDate){
            props.setContent(date);
            props.SetNext();
        }       
    }

    const handleDateChange = (event) => {
        setDate(event)
    }

    const clearDate = () => {
        setDate(null)
    }

    return (
        <div className={classes.container}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="dd/MM/yyyy"                 
                    margin="normal"
                    id="date-picker-inline"
                    label="Choose a date"
                    value={date}
                    minDate={props.addPage.contractDate}
                    onChange={(e) => handleDateChange(e)}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                    className={classes.datePicker}
                />
            </MuiPickersUtilsProvider>
            <Button className={classes.closeButton} onClick={() => clearDate()} >
                <CloseIcon className={classes.closeButtonIcon}></CloseIcon>
            </Button>
            <NextPrevButtons hasPrevious={props.hasPrevious} hasNext={props.hasNext} SetPrevious={props.SetPrevious} SetNext={setNextStep}></NextPrevButtons>
        </div>
    )

}

const useStyles = makeStyles({

    datePicker: {
        width: "95%",
        float: "left",
    },
    closeButton: {
        float: "right",
        "&:hover": {
            background: "#EFEFEF"
        },
        paddingRight: "0px !important",

        minWidth: "36px !important",
        boxSizing: "border-box",
        marginTop: "35px"
    },
    closeButtonIcon: {
        paddingRight: "7px"
    },
    container: {
        marginTop: "20px"
    }

})